import { FirebaseObjectObservable } from 'angularfire2/database-deprecated';

export class ObjectObservable<T> extends FirebaseObjectObservable<T> {}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/base/object-observable.ts